import { useContext, useEffect, useRef, useState } from 'react';
import { OfertasContext } from '../context/ofertas-context';
import { useOfertasTracker } from '../helpers/use-ofertas-tracker';
import { CarlineWithOfertas } from '../services/ofertas-service/models/ofertas';

export const useOfertasFilter = () => {
	const { ofertasService } = useContext(OfertasContext);
	const { trackOfertasGenericFeatureAppLoad, trackOfertasVehiclePageLoad } = useOfertasTracker();

	const [filteredCarlines, setFilteredCarlines] = useState<CarlineWithOfertas[]>([]);
	const [selectedGamaFilter, setSelectedGamaFilter] = useState<string | null>(null);
	const [selectedMotorizacionFilter, setSelectedMotorizacionFilter] = useState<string | null>(null);
	const isFilterSelectedRef = useRef<boolean>(false);

	const handleFilteredCarlines = (selectedButton: string) => {
		if (selectedGamaFilter === selectedButton || selectedMotorizacionFilter === selectedButton) {
			return;
		}
		isFilterSelectedRef.current = true;
	};

	useEffect(() => {
		const carlines = ofertasService.filterOfertas(selectedGamaFilter, selectedMotorizacionFilter);
		setFilteredCarlines(carlines);

		if (carlines.length > 0) {
			const carline = carlines[0];

			if (!isFilterSelectedRef.current) {
				trackOfertasGenericFeatureAppLoad(carline);
			} else {
				trackOfertasVehiclePageLoad(carline);
				isFilterSelectedRef.current = false;
			}
		}
	}, [selectedGamaFilter, selectedMotorizacionFilter, ofertasService]);

	return {
		filteredCarlines,
		handleFilteredCarlines,
		selectedGamaFilter,
		setSelectedGamaFilter,
		selectedMotorizacionFilter,
		setSelectedMotorizacionFilter,
	};
};
